import {PWMAT_RESOURCE} from './consts'

export const COURSE_VEDIO = [{
  name:'PWmat基本输入输出介绍以及实例演示',
  url:PWMAT_RESOURCE+'course-vedio/20180328.mp4',
  file_name:'20180328.mp4'
},
  {
    name:'PWmat所有输入参数详细介绍',
    url:PWMAT_RESOURCE+'course-vedio/20180517.mp4',
    file_name:'20180517.mp4'
  },
  {
    name:'NEB计算过程详细介绍',
    url:PWMAT_RESOURCE+'course-vedio/20180605.mp4',
    file_name:'20180605.mp4'
  },
{
  name:'大体系计算方法Charge Patching Method原理以及应用介绍(主讲人:Lin-wang Wang)',
  url:'https://v.douyu.com/show/kDe0W21Gz9RMA4Bz',
  file_name:'视频回顾'
},
{
  name:'半导体中点缺陷发光量子效率和寿命的第一性原理研究(主讲人:Lin Shi)',
  url:'https://v.douyu.com/show/3rob7jD64dkWgkZl',
  file_name:'视频回顾'
},
{
  name:'Theoretical Study of Halide Perovskites for Solar Cell and Optoelectronic Applications(主讲人:Su-huai Wei)',
  url:'https://v.douyu.com/show/kDe0W2R1VX8WA4Bz',
  file_name:'视频回顾'
},
{
  name:'Non-adiabatic Molecular Dynamics and Energy Decomposition from DFT calculation(主讲人:Jun Kang)',
  url:'https://v.douyu.com/show/aRbBv3o2nV4v6PYV',
  file_name:'视频回顾'
},
{
  name:'2019新型冠状病毒介绍与抗病毒药物设计(主讲人:Ke-xiao Zheng/Yanan Zhang/Lin Shi)',
  url:'https://v.douyu.com/show/n8GzMXldQmxM6qyP',
  file_name:'视频回顾'
},
{
  name:'电子束辐照下材料离化损伤模拟(主讲人:Zeng-Hua Cai)',
  url:'https://v.douyu.com/show/EO0XvNNYKbXvDrBd',
  file_name:'视频回顾'
},
{
  name:'Radiative Damage and Atomic Diffusion in Semiconductor(主讲人:Wen-Hao Liu)',
  url:'https://v.douyu.com/show/Kg1VWRPw5gD7GbNA',
  file_name:'视频回顾'
},
{
  name:'低维非金属催化剂的计算设计(主讲人:Ji-Jun Zhao)',
  url:'https://v.douyu.com/show/aRbBv3oGyGYv6PYV',
  file_name:'视频回顾'
},
{
  name:'龙讯讲坛第九期:维度无关的半导体缺陷计算理论(主讲人:Hui-Xiong Deng)',
  url:'https://v.douyu.com/show/NbwE7ZGrqDdMn5Zz',
  file_name:'第九期视频回顾'
},
{
  name:'龙讯讲坛第十期:催化老司机带你玩转合成氨(主讲人:cheng-hua Sun)',
  url:'https://v.douyu.com/show/LDBbMAomQALvyJRP',
  file_name:'第十期视频回顾'
},
{
  name:'龙讯讲坛第十一期:非线性光学晶体材料的计算与高通量筛选(主讲人:Bin-Bin Zhang)',
  url:'https://v.douyu.com/show/1LDR7QGZNGZWJzx8',
  file_name:'第十一期视频回顾'
},
]
